import { type ReactNode } from 'react';
interface QuoteSectionProps {
  title: string;
  children: ReactNode;
}

/** 견적 폼 섹션 — 회색 라벨 + 흰 카드 (Figma panel, 재사용). */
export function QuoteSection({
  title,
  children
}: QuoteSectionProps) {
  return <section className="flex w-full flex-col gap-xs" data-sentry-component="QuoteSection" data-sentry-source-file="QuoteSection.tsx">
      <h4 className="px-xs text-body-md-bold text-alternative">{title}</h4>
      <div className="flex w-full flex-col gap-lg rounded-md bg-default p-lg shadow-xs">
        {children}
      </div>
    </section>;
}